import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIClient } from 'src/app/core/api-client/contracts/api-client.service';
import { ICulture } from '../models/resource.model';

@Injectable({
    providedIn: 'root'
})
export class CultureService {

    private api = 'culture';

    constructor(private client: APIClient) { }

    getAll$(): Observable<ICulture[]> {
        return this.client.get<ICulture[]>(`${this.api}/getActiveCultures`);
    }

    getDefaultCulture$(): Observable<ICulture> {
        return this.client.get<ICulture>(`${this.api}/getDefaultCulture`);
    }

    getById$(id: number): Observable<ICulture> {
        return this.client.get<ICulture>(`${this.api}/GetById/${id}`);
    }

}